<template>
  <el-dialog
    title="详情"
    :visible.sync="visible"
    width="80%"
    append-to-body
    @open="handleOpen"
    :before-close="handleClose"
  >
    <el-button type="primary" size="small">导出数据</el-button>
    <el-button type="danger" size="small">导出失败</el-button>
    <el-form ref="queryFormRef" :model="queryParams" style="margin-top: 10px;" :inline="true">
        <el-form-item label="发送方:" prop="account">
          <el-input
            v-model="queryParams.account"
            placeholder="请输入发送方"
            size="small"
            clearable
            @keyup.enter="handleQuery"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="Search"
            size="small"
            @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="Refresh" size="small" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    <el-table
      :data="tableData"
      border
      max-height="350"
      style="width: 100%;"
    >
      <el-table-column prop="account" show-overflow-tooltip label="发送方"> </el-table-column>
      <el-table-column prop="targetUser" label="接收放"> </el-table-column>
      <el-table-column prop="hellostring" label="发送消息"> </el-table-column>
      <el-table-column prop="type" label="状态">
        <template #default="scope">
          <el-tag v-if="scope.row.type == 'success'" type="success"
            >成功</el-tag
          >
          <el-tag v-else type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="errTxt" show-overflow-tooltip label="错误信息" width="300px">
        <template #default="scope">
          <div v-if="scope.row.errTxt" style="color: #f56c6c;">{{scope.row.errTxt}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="timestamp" label="发送时间" width="180">
        <template #default="scope">
          <div>{{ formatTime(scope.row.timestamp) }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="penye"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        account:undefined,
        pageNum: 1,
        pageSize: 10
      },
    };
  },
  methods: {
    formatTime(timestamp) {
      const date = new Date(timestamp); // 转换为 Date 对象
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    handleClose() {
      this.$emit("close");
    },
    handleOpen() {
      this.reast();
      this.getList();
    },
    reast() {
      this.queryParams = {
        account: undefined,
        pageNum: 1,
        pageSize: 10,
      };
    },
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    resetQuery() {
      this.reast();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    getList() {
      let params = {
        uid: this.rowData.uid,
        targetUser: this.rowData.targetUser,
        account: this.rowData.account
      };
      Object.assign(params, this.queryParams);
      this.$http.post("/client/queryGreetTaskDetail", params).then((res) => {
        this.tableData = res.rows;
        this.total = res.total;
      });
    },
  },
};
</script>
<style scoped>
.penye {
  margin-top: 20px;
  padding-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}
</style>
